const DropdownStyle = {
  FullWidth: 'fullWidth',
  Default: '_default',
};

export default DropdownStyle;
